import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { Season } from '../../../objects';

@Injectable()
export class SeasonService {

  private cache: Season[];

  constructor(private apiSvc: ApiService) { }

  public loadEntites(): Promise<Season[]> {

    const p = new Promise<Season[]>((resolve, reject) => {

      if (this.cache && this.cache.length > 0) {
        console.log("Season cache detected");
        resolve(this.cache);
        return;
      }

      this.apiSvc.get("api/Season/", null).subscribe(
        (data: Season[]) => {
          console.log(data);
          this.cache = data;
          resolve(this.cache);
        },
        (err) => {
          console.log("error", err);
        }
      );

  });

  return p;

}

public getItem(itemId: number): Promise<Season> {

  const p = new Promise<Season>((resolve, reject) => {

    this.apiSvc.get("api/Season/GetItem/" + itemId, null).subscribe(
      (data: Season) => {
        console.log("Season/GetItem", data);
        resolve(data);
      },
      (err) => {
        console.log("error", err);
      }
    );

  });

  return p;
}

  public save(model: Season): Promise<Season> {

    const p = new Promise<Season>((resolve, reject) => {

      this.apiSvc.post("api/Season/save", model).subscribe(
        (data: Season) => {
            resolve(data);
        },
        (err) => {
          console.log("error", err);
        //  this.isLoading = false;
        }
      );

    });

  return p;
  }
}
